import { render, staticRenderFns } from "./WebsiteIntro.vue?vue&type=template&id=925162b8"
import script from "./WebsiteIntro.vue?vue&type=script&lang=js"
export * from "./WebsiteIntro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports